import { useContext, useEffect, useState } from 'react';
import { XYZ } from 'ol/source';
import { Tile } from 'ol/layer';

import { MapContext } from 'contexts/MapContext';
import { useLayers } from 'hooks/useLayers';
import { useOptions } from 'hooks/useOptions';
import { toast } from 'react-toastify';

interface ITileLayer {
  source: XYZ;
  zIndex: number;
}

export function MapLayer({ source, zIndex }: ITileLayer) {
  const { map, handleRemoveOverlayLayers, handleAddAllOverlayLayers } = useContext(MapContext);
  const { layersActived, handleClearLayersActived } = useLayers();
  const { openMap } = useOptions();
  const [ loadInicial, setLoadInicial ] = useState<boolean>(false);

  useEffect(() => {
    if (!map) return;

    const tileLayerConfig = new Tile({
      source,
      zIndex,
      properties: {
        isBaseMap: true,
      },
    });

    map.addLayer(tileLayerConfig);

    tileLayerConfig.setZIndex(zIndex);
    
    const onError = () => {
      if (!toast.isActive('error-loading-tiles')) {
        toast.error('Erro no carregamento do mapa', {
          toastId: 'error-loading-tiles',
          autoClose: loadInicial? 5000 : false,
        });
      }
    }

    const onSuccess = () => {
      setLoadInicial(true);
      if (toast.isActive('error-loading-tiles')) {
        toast.update('error-loading-tiles', {
          autoClose: 5000,
        });
      }
    }
    
    source.on('tileloaderror', onError);
    source.once('tileloadend', onSuccess);

    // eslint-disable-next-line
    return () => {
      map.removeLayer(tileLayerConfig);
      if (layersActived && !openMap) {
        handleRemoveOverlayLayers(layersActived);
        handleAddAllOverlayLayers(layersActived);
      }
      if (layersActived && openMap) {
        handleClearLayersActived();
      }
    };
  }, [map, source]);

  return null;
}
